import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  clearDetailedAnalysis,
  getDeatailedAnalysis,
} from '../../../../../../store/deals/deals.actions';
import { RootState } from '../../../../../../store/store';
import { PaginationArrow } from '../../emailSection/components/paginationArrow/PaginationArrow';

export const DetailedHeaderPagination: React.FC = () => {
  const user = useSelector((state: RootState) => state.auth.user);

  const { detailedAnalysis, selectedBranch } = useSelector(
    (state: RootState) => state.deals
  );

  const [branchNumber, setBranchNumber] = useState(0);

  const history = useHistory();

  const dispatch = useDispatch();

  const currentBranchIndex =
    detailedAnalysis?.engagement?.branchIds?.length &&
    selectedBranch?.branchId?.length
      ? detailedAnalysis?.engagement.branchIds.findIndex(
          (el) => selectedBranch?.branchId === el
        )
      : null;

  const currentBranchNumber =
    typeof currentBranchIndex === 'number' ? currentBranchIndex + 1 : 0;

  const leftArrowDisabled =
    typeof currentBranchIndex !== 'number' || currentBranchIndex === 0;

  const totalBranches = detailedAnalysis?.engagement?.branchIds?.length;

  const rightArrowDisabled =
    (typeof currentBranchIndex === 'number' &&
      typeof totalBranches === 'number' &&
      currentBranchIndex + 1 >= totalBranches) ||
    !detailedAnalysis?.engagement?.engagementId?.length ||
    typeof currentBranchIndex !== 'number' ||
    typeof totalBranches !== 'number';

  const buttonGoDisabled =
    !branchNumber ||
    (typeof currentBranchNumber === 'number' &&
      typeof totalBranches === 'number' &&
      (branchNumber === currentBranchNumber || branchNumber > totalBranches)) ||
    !detailedAnalysis?.engagement?.branchIds?.length ||
    typeof currentBranchIndex !== 'number' ||
    typeof totalBranches !== 'number';

  const goToAnotherBranch = (engagementId: string, branchId: string) => {
    if (user) {
      const { userId, orgId } = user;

      dispatch(clearDetailedAnalysis());

      history.push(
        `/orgs/${orgId}/users/${userId}/engagements/${engagementId}/threads/${branchId}`
      );

      dispatch(
        getDeatailedAnalysis(user?.orgId, user?.userId, engagementId, branchId)
      );
    }
  };

  const leftArrowClick = () => {
    if (!leftArrowDisabled && typeof currentBranchIndex === 'number') {
      const nextBranchId = detailedAnalysis?.engagement?.branchIds.find(
        (el, i) => i === currentBranchIndex - 1
      );

      if (
        nextBranchId?.length &&
        detailedAnalysis?.engagement?.engagementId?.length
      ) {
        goToAnotherBranch(
          detailedAnalysis?.engagement?.engagementId,
          nextBranchId
        );
      }
    }
  };

  const rightArrowClick = () => {
    if (!rightArrowDisabled && typeof currentBranchIndex === 'number') {
      const prevBranchId = detailedAnalysis?.engagement?.branchIds.find(
        (el, i) => i === currentBranchIndex + 1
      );

      if (
        prevBranchId?.length &&
        detailedAnalysis?.engagement?.engagementId?.length
      ) {
        goToAnotherBranch(
          detailedAnalysis?.engagement?.engagementId,
          prevBranchId
        );
      }
    }
  };

  const setValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e?.currentTarget?.value) {
      setBranchNumber(+e?.currentTarget?.value);
    }
  };

  const onKeyEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.code.includes('Digit')) {
      setBranchNumber(+e?.currentTarget?.value);
    }
  };

  const clickGo = () => {
    if (!buttonGoDisabled) {
      const branchIdToRedirect = detailedAnalysis?.engagement?.branchIds.find(
        (el, i) => i === branchNumber - 1
      );

      if (
        branchIdToRedirect?.length &&
        detailedAnalysis?.engagement?.engagementId.length
      ) {
        goToAnotherBranch(
          detailedAnalysis?.engagement?.engagementId,
          branchIdToRedirect
        );
      }
    }
  };

  const attrs = {
    wrapper: {
      className: 'eng-pagination',
    },

    arrowSection: {
      wrapper: {
        className: 'eng-pagination__arrow-section',
      },

      arrowWrapper: {
        className: 'eng-pagination__arrow-section__wrapper',
      },

      leftArrow: {
        className: `${
          leftArrowDisabled ? 'disabled' : ''
        } eng-pagination__arrow-section__wrapper-left`,
        onClick: leftArrowClick,
        disabled: leftArrowDisabled,
      },

      leftArrowTooltip: {
        className: 'eng-pagination__arrow-section__wrapper-left-tooltip',
        style: { display: leftArrowDisabled ? 'none' : '' },
      },

      rightArrow: {
        className: `${
          rightArrowDisabled ? 'disabled' : ''
        } eng-pagination__arrow-section__wrapper-right`,
        onClick: rightArrowClick,
        disabled: rightArrowDisabled,
      },

      rightArrowTooltip: {
        className: 'eng-pagination__arrow-section__wrapper-right-tooltip',
        style: { display: rightArrowDisabled ? 'none' : '' },
      },

      pageNumbers: {
        className: 'eng-pagination__arrow-section-pages',
      },
    },

    divider: {
      className: 'eng-pagination-divider',
    },

    inputSection: {
      wrapper: {
        className: 'eng-pagination__input-section',
      },

      text: {
        className: 'eng-pagination__input-section-text',
      },

      input: {
        className: 'eng-pagination__input-section-input',
        type: 'number',
        min: 1,
        max: totalBranches || 0,
        onChange: setValue,
        onKeyDown: onKeyEnter,
        pattern: '(/^[0-9]+$/)',
        disabled:
          (leftArrowDisabled && rightArrowDisabled) ||
          !totalBranches ||
          totalBranches <= 1,
      },

      button: {
        className: `${
          buttonGoDisabled ? 'disabled' : ''
        } eng-pagination__input-section-button`,
        onClick: clickGo,
      },
    },
  };

  const dataCheck = detailedAnalysis;

  return (
    <div {...attrs.wrapper}>
      {dataCheck ? (
        <>
          <div {...attrs.arrowSection.wrapper}>
            <div {...attrs.arrowSection.arrowWrapper}>
              <PaginationArrow {...attrs.arrowSection.leftArrow} />
              <div {...attrs.arrowSection.leftArrowTooltip}>
                Previous thread
              </div>
            </div>

            <div {...attrs.arrowSection.pageNumbers}>
              {currentBranchNumber} / {totalBranches}
            </div>
            <div {...attrs.arrowSection.arrowWrapper}>
              <PaginationArrow {...attrs.arrowSection.rightArrow} />
              <div {...attrs.arrowSection.rightArrowTooltip}>Next thread</div>
            </div>
          </div>
          <div {...attrs.divider} />
          <div {...attrs.inputSection.wrapper}>
            <div {...attrs.inputSection.text}>Jump to</div>
            <input {...attrs.inputSection.input} />
            <div {...attrs.inputSection.button}>Go</div>
          </div>
        </>
      ) : null}
    </div>
  );
};
